import './App.css';
import { AppRouter } from './core/router/AppRouter';
import { AccountSessionWatcher } from './core/components/AccountSessionWatcher';

function App() {
  return (
    <AccountSessionWatcher>
      <AppRouter/>
    </AccountSessionWatcher>
  );
}

export default App;
